import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import ProtectedRoute from "./routes/protectedRoutes";
import ScreenLoader from "./components/UtilityComponents/loaders/screenLoader/ScreenLoader";
import { MixPanelGlobalTracker } from "./components/analytics/MixPanelGlobalTracker";
import MobileAlert from "./components/mobileAlert/MobileAlert";
import { initializeTheme, clearTheme } from "./theme/themeConfig";

import "./scss/style.scss";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const JobLandingPage = React.lazy(
  () => import("./views/pages/jobLandingPage/JobLandingPage"),
);
const JobLandingAll = React.lazy(
  () => import("./views/pages/jobLandingAll/JobLandingAll"),
);
const TermsOfService = React.lazy(
  () => import("./views/pages/termsOfService/TermsOfService"),
);

const App = () => {
  // Apply theme (color scheme) once when app loads
  useEffect(() => {
    initializeTheme();
    return () => {
      clearTheme();
    };
  }, []);

  return (
    <ToastProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<ScreenLoader />}>
            <MixPanelGlobalTracker />
            <MobileAlert>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/login/*" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/404" element={<Page404 />} />
                <Route path="/500" element={<Page500 />} />
                <Route
                  path="/recruitment/job-posts"
                  element={<JobLandingAll />}
                />
                <Route
                  path="/recruitment/job-posts/:jobPostUUID"
                  element={<JobLandingPage />}
                />
                <Route
                  path="/recruitment/*"
                  element={<Navigate to="/recruitment/job-posts" replace />}
                />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <DefaultLayout />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </MobileAlert>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ToastProvider>
  );
};

export default App;
